import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import DataTable from './DataTable';
import NavLink from '@/components/NavLink';

const GradePage = () => {
  return (
    <Panel
      header={
        <>
          <h3 className="title">Grades</h3>
          <Breadcrumb>
            <Breadcrumb.Item to="/" as={NavLink}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Grades</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <DataTable />
    </Panel>
  );
};

export default GradePage;
